import { useState, useEffect } from 'react';
import { reminderService } from '../services/reminders';

export const useReminders = () => {
  const [reminders, setReminders] = useState(reminderService.getReminders());

  useEffect(() => {
    // Solicita permissão para notificações
    if ('Notification' in window) {
      Notification.requestPermission();
    }
  }, []);

  const addVoiceReminder = (command: string) => {
    const reminderData = reminderService.parseVoiceCommand(command);
    if (!reminderData.datetime) {
      reminderData.datetime = new Date();
    }
    
    const newReminder = reminderService.addReminder({
      ...reminderData,
      completed: false,
      datetime: reminderData.datetime
    });

    setReminders(reminderService.getReminders());
    return newReminder;
  };

  const toggleReminder = (id: string) => {
    const reminder = reminders.find(r => r.id === id);
    if (reminder) {
      reminderService.updateReminder(id, { completed: !reminder.completed });
      setReminders(reminderService.getReminders());
    }
  };

  const deleteReminder = (id: string) => {
    reminderService.deleteReminder(id);
    setReminders(reminderService.getReminders());
  };

  return {
    reminders,
    addVoiceReminder,
    toggleReminder,
    deleteReminder
  };
};
